/* Purpose: This is the front page for the client's portal. No data can be viewed or inputed on this page.
 * Props: GlobalVar (map)
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React, {useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PortalNavBar from '../Layout/PortalNavBar';
import PageTitle from '../Components/PageTitle';
import SloganHeader from '../Components/SloganHeader';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SubmitButton from '../Components/Button';

const Portal = ({GlobalVar}) => {
  const cardInfo = [{"Path":"General", "LinkText":"Fill Out General Information", "Header":"Step 1", "Body":"Fill out your relevant personal and financial information, upload the necessary documents and save the form."},
                    {"Path": "Loans?createNewLoan=true", "LinkText": "Apply For a New Loan", "Header": "Step 2", "Body":"Create a new loan in your portal. Fill out the relevant loan information, upload the necessary documents, and save the form.", "Addition":
                      {"Path": "Loans", "LinkText": "Open An Exisiting Loan", "Header": "OR", "Body": "Find your existing loan and continue where you left off."}
                    },
                    {"Path": "Review", "LinkText":"Review", "Header": "Step 3", "Body": "Review your information and ensure that you uploaded all the necessary documents. Return to the applicable forms to make any necessary changes."}
                  ]

  // Remove the auth code if there is a code attached as query string params
  useEffect(() => {
      const currentLocation = window.location.href;

      if (currentLocation.includes("?code=")){
          window.location.href = GlobalVar.PORTAL_URL;  
      }
      
      window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
  }, []);



  return (
    <div>
      <PortalNavBar />
      <SloganHeader/>

      <div className="text-center mt-3 mb-5">
        <PageTitle pageName = {`Client Portal`} />

        <hr width = "80%" className="border-bottom border-3 float-center mx-auto"></hr>

        <Container fluid>
        <Row xs={1} md={3} className="g-4 m-5">
          {cardInfo.map((step, index) => (
            <Col key = {index} className='d-flex col-sm'>
              <Card  bg = "light" className='p-3 flex-fill'>
                <Card.Title>{step.Header}</Card.Title>
                <Card.Text>{step.Body}</Card.Text>

                <Link className="link mt-auto" to={step.Path}><SubmitButton text = {step.LinkText} width = "80" /></Link>
              
                {step.Header == "Step 2" && (
                  <>
                    <Card.Title>{step.Addition.Header}</Card.Title>
                    <Card.Text>{step.Addition.Body}</Card.Text>
                    {step.Addition.Path && (<Link className="link mt-auto" to={step.Addition.Path}><SubmitButton text = {step.Addition.LinkText} width = "80" /></Link>)}
                  </>
                )}

              </Card>
            </Col>
          ))}
        </Row>
        <Row xs={1} md={1} className = "m-5 g-4">
          <Col>
            <Card bg = "light" className='p-3'>
              <Card.Title>That's It!</Card.Title>
              <Card.Text>Windsor Lending will contact you to complete the process.</Card.Text>
            </Card>
          </Col>
        </Row>

        </Container>

        <hr width = "80%" className="border-bottom border-3 float-center mx-auto"></hr>

      </div>
  </div>
  );
}

export default Portal;